"use client";
import React from "react";
import Images from "@/app/assets/shared";
import Image from "next/image";
type RoadMapItem = {
  title: React.ReactNode;
  description: string;
  number: string;
};
interface AIRoadmapProps {
  title: React.ReactNode;
  description: string;
  subtitle: string;
  roadMapArray: RoadMapItem[];
}

const AiRoadmap = ({
  title,
  description,
  subtitle,
  roadMapArray,
}: AIRoadmapProps) => {
  return (
    <section className="relative w-full overflow-hidden px-4 py-16 sm:px-6 md:px-10 lg:px-[100px] lg:py-[100px]">
      <Image
        src={Images?.serviceBg}
        alt="services bg"
        fill
        className="-z-10 object-cover"
        sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        loading="lazy"
      />
      <div className="mx-auto w-full max-w-[5000px]">
        {/* Header Section */}
        <h3 className="text-sm font-medium uppercase leading-[140%] text-white sm:text-base mb-5">
          {subtitle}
        </h3>
        <div className="mb-12 flex flex-col gap-6 lg:mb-[54px] lg:flex-row lg:items-start lg:gap-[30px] justify-between">
          <div className="flex flex-col gap-4 lg:max-w-[845px]">
            <h2 className="clash-font text-[clamp(2.5rem,2.2rem+1.5vw,4.5rem)] font-medium leading-[120%] text-white lg:max-w-[800px]">
              {title}
            </h2>
          </div>
          <p className="text-base font-normal leading-[160%] text-[#949596] sm:text-xl lg:max-w-[845px]">
            {description}
          </p>
        </div>

        {/* Separator Line */}
        <div className="mb-12 h-px w-full bg-white/10 lg:mb-[54px] lg:bg-white/20"></div>

        {/* Roadmap Steps */}
        <div className="w-full lg:ml-[146px] lg:w-[1428px]">
          <div className="flex flex-col gap-10 lg:gap-[44px]">
            {roadMapArray?.map((step, index) => (
              <div key={index} className="flex flex-col">
                <div className="flex flex-col gap-6 sm:px-4 sm:py-4 lg:flex-row lg:items-center lg:gap-[54px] lg:px-0 lg:py-0">
                  {/* Number Circle */}
                  <div className="flex items-center gap-4 sm:gap-6 lg:h-[154px] lg:w-[160px] lg:justify-center lg:gap-0">
                    <div className="ml-0 flex min-h-[60px] min-w-[60px] items-center justify-center rounded-[48px] border border-white/20 px-4 py-2 sm:min-h-[64px] sm:min-w-[64px] sm:px-5 sm:py-2.5 lg:ml-[53px] lg:h-[72px] lg:w-[54px]">
                      <span className="text-lg font-semibold leading-[140%] text-white sm:text-xl">
                        {step.number}
                      </span>
                    </div>
                  </div>

                  {/* Vertical Separator */}
                  <div className="hidden h-[154px] w-px bg-white/20 lg:block"></div>

                  {/* Content */}
                  <div className="flex w-full flex-col gap-4 lg:w-[1160px]">
                    <h3 className="clash-font text-[clamp(1.875rem,1.5rem+1vw,2.375rem)] font-medium leading-[120%] text-white">
                      {step.title}
                    </h3>
                    <p
                      className="text-base font-normal leading-[160%] text-[#949596] sm:text-lg"
                      dangerouslySetInnerHTML={{
                        __html: step.description ?? "",
                      }}
                    />
                  </div>
                </div>

                {/* Horizontal Separator (except for last item) */}
                {index < roadMapArray.length - 1 && (
                  <div className="mt-8 h-px w-full bg-white/10 lg:h-[1px] lg:bg-white/20"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiRoadmap;
